import React, { useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { handlePostRequest } from "../../../../services/PostTemplate";
import { endPoints } from "../../../../Config";

const AddFeature = ({ onHide, getFeatureList }) => {
    const [loadingBtn, setLoadingBtn] = useState(false);

    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        text: Yup.string()
            ?.matches(/^[^\s]+(\s[^\s]+)*$/, "Leading and trailing space is not allowed")
            .required("This field is required"),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            text: "",
        },

        onSubmit: async (data) => {
            setLoadingBtn(true);

            let newData = {
                featureName: data?.text,
            };

            const response = await dispatch(handlePostRequest(newData, endPoints.addFeature, false, true));
            if (response?.statusCode === 200) {
                getFeatureList();
                onHide();
            }
            setLoadingBtn(false);
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="p-fluid formgrid grid pl-2 pr-2">
                    <div className="field col-12 md:col-6">
                        <label> Feature Name </label>
                        <span className="Label__Required">*</span>
                        <InputText placeholder="Enter Feature Name" className={classNames({ "p-invalid": isFormFieldValid("text") }, "Input__Round")} id="text" name="text" maxLength={30} value={formik.values.text} onChange={formik.handleChange} type="text" />
                        {getFormErrorMessage("text")}
                    </div>

                    <div className="col-12 d-flex flex-row text-center mt-4 pb-2">
                        <Button className="Cancel-Button" label="Cancel" type="button" onClick={onHide} />
                        <Button className="Save-Button ml-2" label="Add" type="submit" loading={loadingBtn} />
                    </div>
                </div>
            </form>
        </>
    );
};

export default AddFeature;
